module.exports = __webpack_public_path__ + "static/img/logo_bg.b23a9605.png";